import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './BlogTwo.css';

function BlogTwo() {
  const blogs = [
    {
      img: 'assets/images/blog/blog-1.png',
      day: '20',
      month: 'JUL',
      title: 'Why Timely Audits Boost Business Credibility',
      author: 'AQ Audit Team',
      designation: 'Audit & Compliance',
      description:
        'Conducting regular audits ensures transparency, builds stakeholder trust, and helps mitigate financial risks across growing enterprises.',
    },
    {
      img: 'assets/images/blog/blog-2.png',
      day: '18',
      month: 'JUL',
      title: 'Choosing the Right ERP: A Strategic Guide',
      author: 'AQ Audit Team',
      designation: 'ERP Consulting',
      description:
        'Implementing the right ERP system streamlines operations and enhances decision-making. Discover how to evaluate the best ERP for your business.',
    },
    {
      img: 'assets/images/blog/blog-3.png',
      day: '16',
      month: 'JUL',
      title: 'Mastering VAT Compliance for Modern SMEs',
      author: 'Tax Advisory',
      designation: 'VAT Consulting',
      description:
        'VAT rules can be complex. Learn how our team helps you stay compliant, avoid penalties, and simplify filing processes with clarity.',
    },
    {
      img: 'assets/images/blog/blog-4.png',
      day: '14',
      month: 'JUL',
      title: 'Outsourced Accounting: Benefits for Startups',
      author: 'Finance Desk',
      designation: 'Accounting Services',
      description:
        'Startups save time and costs with outsourced accounting. Here’s how professional bookkeeping can improve financial efficiency.',
    },
  ];

  return (
    <div style={{ paddingTop: 10, paddingBottom: 10, marginTop: 15, marginBottom: 15 }}>
      <div className="container" style={{ paddingTop: 0, paddingBottom: 0 }}>
        <div
          className="section-head section-head-one-side text-align-left"
          style={{ marginBottom: 0 }}
        >
          <div className="section-sub-title color-secondary">
            <span className="subtitle">LATEST BLOG</span>
          </div>
          <h2 className="title split-collab" style={{ marginBottom: 10 }}>
            Latest news &amp; articles from our experts
          </h2>
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={3}
          spaceBetween={30}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          style={{ paddingBottom: 0, marginBottom: 0 }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {blogs.map((blog, index) => (
            <SwiperSlide key={index}>
              <div className="single-blog blog-style-two">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/Blog">
                      <img src={blog.img} alt={blog.title} />
                    </Link>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">{blog.author}</span>
                      <span className="designation">{blog.designation}</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/Blog" className="title-area">
                        <h4 className="title sm-title">{blog.title}</h4>
                      </Link>
                      {blog.description && (
                        <p className='description' style={{ textAlign: 'justify', marginBottom: 0 }}>
                          {blog.description}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default BlogTwo;
